export default __webpack_public_path__ + "static/media/logo_rappi_with_aliados.b53485e0.svg";